import script from "./SecurityGlobalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityGlobalHeader.vue?vue&type=script&setup=true&lang=js"

import "./SecurityGlobalHeader.vue?vue&type=style&index=0&id=de83c7be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de83c7be"]])

export default __exports__